class LocalCache {
  setItem(key: string, value: any) {
    window.localStorage.setItem(key, JSON.stringify(value))
  }
  getItem(key: string) {
    const value = window.localStorage.getItem(key)
    if (value && value !== 'undefined') {
      return JSON.parse(value)
    }
  }
  deleteItem(key: string) {
    window.localStorage.removeItem(key)
  }
  clear() {
    window.localStorage.clear()
  }
}

export default new LocalCache()
